import React from "react";
import { Route, Redirect } from "react-router-dom";
import useIsLoggedIn from "../_hooks/useIsLoggedIn";

export function PrivateRoute({ component: Component, ...rest }) {
  const loggedIn = useIsLoggedIn();
  return (
    <Route
      {...rest}
      render={(props) =>
        loggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        )
      }
    />
  );
}
